import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DriverTracking from "pages/TripTracking";
import MemberReady from "pages/MemberReady";
import TripConfirmation from "pages/TripConfirmation";
import NotFound from "pages/NotFound";
import FundingSource from "pages/Fundingsource";
import FundingSourceLayout from "pages/Fundingsource/FundingSourceLayout";
import TripsListing from "pages/Fundingsource/TripsListing";
import CreateMember from "pages/Fundingsource/CreateMember";
import CreateTrip from "pages/Fundingsource/CreateTrip";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/trip-tracking/:tripId"
          element={<DriverTracking />}
        ></Route>
        <Route
          path="/trip-confirmation/:tripId"
          element={<TripConfirmation />}
        ></Route>
        <Route path="/trip-member-ready/:tripId" element={<MemberReady />}></Route>
        <Route
          path="/fundingsource/:fundingsourceId"
          element={<FundingSourceLayout />}
        >
          <Route index element={<FundingSource />} />
          <Route path="trips/:memberId" element={<TripsListing />} />
          <Route path="create-member/:memberId" element={<CreateMember />} />
          <Route path="trips/create/:memberId" element={<CreateTrip />} />
        </Route>
        <Route path="/expired" element={<NotFound />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={6000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </BrowserRouter>
  );
}

export default App;
